import React from 'react';
import ReactGA from 'react-ga4';

interface PageViewProps {
    path: string;
}

interface EventProps {
    category:string;
    action:string;
    label:string;
    value?:number;
}

interface ModalProps {
    name:string;
}

export function RegisterPageView({path}:PageViewProps) {
    //ReactGA.pageview(path);
    ReactGA.send({hitType: "pageview", page: path});
}

export function RegisterEvent({category, action,label,value=-1}:EventProps) {
    ReactGA.event({
        category:category,
        action:action,
        label: label, 
        value: value
    });
}

export function RegisterModalView({name}:ModalProps) {
    ReactGA.event({
        category: "modalview",
        action: `Viewing modal ${name}`,
        label: name
    });
}